var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from "aurelia-framework";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import { I18N } from "aurelia-i18n";
import { Router } from "aurelia-router";
import { SourceType } from "../../../../../models/queries/queries.models";
import * as Enumerable from "linq";
import { QueriesEditor } from "../../../../components/queries/queries-editor";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
var InstantGameTicketLines = /** @class */ (function (_super) {
    __extends(InstantGameTicketLines, _super);
    function InstantGameTicketLines(dialogClient, notificationService, i18N, queriesService, router) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.dialogClient = dialogClient;
        _this.queriesService = queriesService;
        _this.router = router;
        _this.filterTransactionId = null;
        _this.showInDialogBox = false;
        return _this;
    }
    InstantGameTicketLines.prototype.onActivated = function (item) {
        if (this.item.dialogNavigationInfo.transactionId) {
            this.filterTransactionId = this.item.dialogNavigationInfo.transactionId;
            this.dialogAdditionalData = this.item.dialogNavigationInfo;
            this.showInDialogBox = true;
        }
        this.reLoad(item);
    };
    Object.defineProperty(InstantGameTicketLines.prototype, "paramsForDialogHeader", {
        get: function () {
            return { 'transactionId': this.filterTransactionId };
        },
        enumerable: false,
        configurable: true
    });
    InstantGameTicketLines.prototype.getPath = function () {
        return "InstantGameTicketLines";
    };
    InstantGameTicketLines.prototype.GetFilteringQuery = function () {
        if (this.filterTransactionId)
            return "/odata/".concat(this.getPath(), "?$filter=transactionId eq ").concat(this.filterTransactionId);
        if (this.item.instantGameId)
            return "/odata/".concat(this.getPath(), "?$filter=instantGameId eq ").concat(this.item.instantGameId);
        return null;
    };
    InstantGameTicketLines.prototype.reLoad = function (item) {
        var _this = this;
        if (this.GetFilteringQuery()) {
            this.queriesService.getEntityModels().then(function (models) {
                var e_1, _a;
                var columns = [];
                var selectedModel = Enumerable.from(models).firstOrDefault(function (y) { return y.uri == _this.getPath(); });
                try {
                    for (var _b = __values(selectedModel.projectionProperties), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item_1 = _c.value;
                        var column = QueriesEditor.generateDefaultColumn(item_1, selectedModel);
                        ;
                        if (column.name == "mainPicks" || column.name == "bonusPicks") {
                            column.valueConverter = function (x) { return x ? Enumerable.from(x.split(",")).orderBy(function (x) { return Number(x); }).toJoinedString(",") : ""; };
                        }
                        columns.push(column);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                var oDataUrl = _this.GetFilteringQuery();
                _this.itemSource = {
                    source: oDataUrl,
                    sourceType: SourceType.ODataUrl,
                    columns: columns,
                    groupInitialFilters: true
                };
            }).catch(function (error) {
                _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
            });
        }
    };
    InstantGameTicketLines.prototype.reloadDataGrid = function () {
        this.dataGrid.reloadData();
    };
    InstantGameTicketLines.prototype.closeDialog = function () {
        this.dialogClient.hide();
    };
    InstantGameTicketLines = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [DialogClientService,
            NotificationClientService,
            I18N,
            QueriesClientService,
            Router])
    ], InstantGameTicketLines);
    return InstantGameTicketLines;
}(ChildComponent));
export { InstantGameTicketLines };
